var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupmodalimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 157,
    viewBox: "0 0 194 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3602 127.229C125.36 127.229 148.06 104.529 148.06 76.4289C148.06 48.3289 125.26 25.6289 97.3602 25.6289C69.3602 25.6289 46.6602 48.3289 46.6602 76.4289C46.6602 104.529 69.3602 127.229 97.3602 127.229Z",
    fill: "#1976D2",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.76 43.1258C147.025 43.1258 148.86 41.2901 148.86 39.0258C148.86 36.7614 147.025 34.9258 144.76 34.9258C142.496 34.9258 140.66 36.7614 140.66 39.0258C140.66 41.2901 142.496 43.1258 144.76 43.1258Z",
    fill: "#1976D2",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.761 27.1273C152.307 27.1273 153.561 25.8737 153.561 24.3273C153.561 22.7809 152.307 21.5273 150.761 21.5273C149.215 21.5273 147.961 22.7809 147.961 24.3273C147.961 25.8737 149.215 27.1273 150.761 27.1273Z",
    fill: "#1976D2",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3605 43.0258C50.9069 43.0258 52.1605 41.7722 52.1605 40.2258C52.1605 38.6794 50.9069 37.4258 49.3605 37.4258C47.8141 37.4258 46.5605 38.6794 46.5605 40.2258C46.5605 41.7722 47.8141 43.0258 49.3605 43.0258Z",
    fill: "#1976D2",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.463 111.041L58.3044 111.447C53.793 111.462 50.1143 108.828 50.0539 105.583L49.4482 51.4423C49.4229 48.1753 53.0551 45.5144 57.5362 45.4743L135.695 45.0683C140.206 45.0537 143.885 47.6869 143.945 50.9319L144.551 105.073C144.576 108.34 140.944 111.001 136.463 111.041Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.062 102.958L63.3538 103.335C61.4103 103.347 59.846 102.237 59.8266 100.829L59.3053 56.0841C59.2858 54.6767 60.818 53.5452 62.7616 53.5327L131.469 53.1562C133.413 53.1437 134.977 54.2545 134.997 55.6619L135.518 100.407C135.537 101.814 134.005 102.946 132.062 102.958Z",
    fill: "#1976D2",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.501 113.238C112.191 114.556 111.726 115.951 111.183 117.114C109.71 119.982 107.385 122.23 104.516 123.703C101.571 125.176 98.0821 125.796 94.5937 125.021C86.3766 123.316 81.1052 115.253 82.8107 107.036C84.5161 98.8192 92.5007 93.4703 100.718 95.2533C103.664 95.8735 106.222 97.3463 108.392 99.3619C112.036 103.005 113.586 108.277 112.501 113.238Z",
    fill: "#1976D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4824 110.777L95.4824 115.91L105.482 104.91",
    stroke: "#1976D2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4824 110.777L95.4824 115.91L105.482 104.91",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupmodalimg);
export default __webpack_public_path__ + "static/media/Groupmodalimg.2b73b4485852abcf72c4df4394d414e8.svg";
export { ForwardRef as ReactComponent };